import React from 'react';

const LegalChargeDetailsDialogUI = ({ isOpen, onClose, details }) => {
  if (!details || !details.length) return null;

  const formatDate = (dateStr) => {
    if (!dateStr || dateStr === 'N/A') return 'Not Paid';
    if (dateStr.toLowerCase() === 'not paid') return 'Not Paid';
    const [year, month, day] = dateStr.split('-');
    return `${day}-${month}-${year}`;
  };

  const parseDetail = (detail) => {
    const parts = detail.split(',');
    if (parts.length < 6) {
      console.warn("Skipping invalid detail string:", detail);
      return null;
    }

    const [amount, dueDate, paid, paidDate, pending /* status */] = parts;
    return { amount, dueDate, paid, paidDate, pending };
  };

  const convertPaiseToRupee = (str) => {
    const num = Number(str);
    return isNaN(num) ? 0 : num / 100;
  };

  let totalAmount = 0;
  let totalPaidAmount = 0;
  let totalPendingAmount = 0;

  return (
    <div className='popup' style={isOpen ? { display: 'flex' } : { display: 'none' }}>
      <div
        className='popup-inner'
        style={{
          maxWidth: '95vw',
          width: '900px',
          overflowX: 'auto',
          paddingBottom: '1rem'
        }}
      >
        <div className='g_flex_h' style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <h2>Legal Charge Details</h2>
          <button
            style={{ border: 'none', background: 'none', fontSize: '24px', cursor: 'pointer' }}
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table className='popup-table' style={{ minWidth: '800px' }}>
            <thead>
              <tr>
                <th>Amount Due</th>
                <th style={{ minWidth: '110px' }}>Due Date</th>
                <th>Amount Paid</th>
                <th style={{ minWidth: '110px' }}>Paid Date</th>
                <th>Pending Amount</th>
              </tr>
            </thead>
            <tbody>
              {details.map((detail, index) => {
                const parsed = parseDetail(detail);
                if (!parsed) return null;

                const { amount, dueDate, paid, paidDate, pending } = parsed;

                const parsedAmount = convertPaiseToRupee(amount);
                const parsedPaid = convertPaiseToRupee(paid);
                const parsedPending = convertPaiseToRupee(pending);

                totalAmount += parsedAmount;
                totalPaidAmount += parsedPaid;
                totalPendingAmount += parsedPending;

                return (
                  <tr key={index}>
                    <td>{parsedAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                    <td>{formatDate(dueDate)}</td>
                    <td>{parsedPaid.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                    <td>{formatDate(paidDate)}</td>
                    <td>{parsedPending.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                  </tr>
                );
              })}
              {/* Totals Row */}
              <tr style={{ fontWeight: 'bold' }}>
                <td style={{ color: '#cc4444' }}>
                  {totalAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </td>
                <td></td>
                <td style={{ color: '#cc4444' }}>
                  {totalPaidAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </td>
                <td></td>
                <td style={{ color: '#cc4444' }}>
                  {totalPendingAmount.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LegalChargeDetailsDialogUI;
